import { Address } from "../model/address";
import axios from "axios";
import { Property } from "../../../businessFoundation/MetaClassData/MetaClassDataList/MetaClassDataModel";

export const fetchAddressesInContact = async (contactId: string): Promise<Address[]> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<Address[]>(url + "Addresses/GetByContactId?contactId=" + contactId);
    return res.data;
};

export const fetchAddressesInOrganization = async (orgId: string): Promise<Address[]> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<Address[]>(url + "Addresses/GetByOrganizationId?orgId=" + orgId);
    return res.data;
};

export const fetchAddressById = async (addressId: string): Promise<Address> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<Address>(url + "Addresses/Get?addressId=" + addressId);
    return res.data;
};

export const updateAddress = async (address: Address): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.post<any>(url + "Addresses/AddOrUpdate", address);
};

export const deleteAddress = async (addressIds: string[]): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.delete<any>(url + "Addresses/Delete/", { data: addressIds });
};

export const fetchExtendedProperties = async (className: string): Promise<Property[]> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<Property[]>(
        url + "Common/GetExtendedPropertiesByClassName?className=" + className
    );
    return res.data;
};
